{
  "name": "@databricks/sdk-auth",
  "version": "0.21.0",
  "description": "Databricks authentication library for JavaScript/TypeScript",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "default": "./dist/index.js"
    },
    "./credentials": {
      "types": "./dist/credentials/index.d.ts",
      "import": "./dist/credentials/index.js",
      "default": "./dist/credentials/index.js"
    },
    "./credentials/browser": {
      "types": "./dist/credentials/index.browser.d.ts",
      "import": "./dist/credentials/index.browser.js",
      "default": "./dist/credentials/index.browser.js"
    },
    "./oidc": {
      "types": "./dist/oidc/index.d.ts",
      "import": "./dist/oidc/index.js",
      "default": "./dist/oidc/index.js"
    },
    "./oidc/browser": {
      "types": "./dist/oidc/index.browser.d.ts",
      "import": "./dist/oidc/index.browser.js",
      "default": "./dist/oidc/index.browser.js"
    }
  },
  "files": [
    "dist",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsc -b",
    "lint": "eslint src tests --ext .ts",
    "lint:fix": "eslint src tests --ext .ts --fix",
    "format": "prettier --write \"src/**/*.ts\" \"tests/**/*.ts\"",
    "format:check": "prettier --check \"src/**/*.ts\" \"tests/**/*.ts\"",
    "test": "vitest run",
    "test:browser": "vitest run --config vitest.config.browser.ts",
    "typecheck": "tsc --noEmit",
    "clean": "rm -rf dist tsconfig.tsbuildinfo"
  },
  "author": "Databricks",
  "license": "Apache-2.0",
  "engines": {
    "node": ">=22.0.0"
  },
  "dependencies": {
    "@databricks/sdk-core": ">=0.21.0 <1.0.0",
    "zod": "^4.3.6"
  }
}
